import React from 'react';
import { Grid, TextField, Typography } from '@mui/material';
import { ECCommonErrorBlock } from '@/components/Forms/ECCommonErrorBlock';
import { ECTextField } from '@/components/Forms/ECTextField';
import { ECDateField } from '@/components/Forms/ECDateField';
import { ECSelectField } from '@/components/Forms/ECSelectField';
import moment from 'moment-timezone';

export const convertErrors = (errors, idx) => {
  if (!errors || errors.length === 0) {
    return {
      isValid: true,
      errors: {},
      touched: {},
    };
  }

  const fieldErrors = {};
  const touched = {};
  let mainError = null;
  errors.forEach(e => {
    if (e.args && e.args.field && e.args.field !== 'fields') {
      let idx2;
      if (idx) {
        idx = idx.toString();
        idx2 = [...e.args.field.matchAll(/fields\[(\d+)\].*/g)];
        idx2 = idx2[0][1];
      }
      let fieldName = idx ? e.args.field.slice(e.args.field.indexOf('.') + 1) : e.args.field;
      if (!fieldErrors[e.args.field] && (idx ? idx === idx2 : true)) {
        fieldErrors[fieldName] = e.message;
        touched[fieldName] = true;
      }
    } else if (mainError === null) {
      mainError = e.message || JSON.stringify(e);
    }
  });

  let ret = {
    isValid: false,
    error: mainError,
    errors: fieldErrors,
    touched: touched,
  };
  return ret;
};

// TODO: remove and migrate to react-hook-form
export const MyFormTextField = props => {
  const { data: formData, name, label, handleChange, error, ...rest } = props;

  const parts = name.split('.');
  let val = formData.values;
  parts.forEach(p => (val = val[p]));
  return (
    <TextField
      label={label}
      {...rest}
      fullWidth
      margin='dense'
      variant='outlined'
      autoComplete='new-password'
      helperText={error(name)}
      error={error(name) != null}
      onChange={e => handleChange(name, e.target.value)}
      value={val || ''}
    />
  );
};

const MeetupEditForm = props => {
  const { form, initial } = props;

  return (
    <>
      <ECCommonErrorBlock form={form} />
      <Grid container spacing={3}>
        <Grid size={12}>
          <ECTextField label='Название мероприятия' name='name' form={form} initial={initial} />
        </Grid>
        <Grid size={6}>
          <ECDateField label='Дата начала' name='startTime' form={form} initial={initial} />
        </Grid>
        <Grid size={6}>
          <ECDateField label='Дата окончания' name='endTime' form={form} initial={initial} />
        </Grid>
        <Grid size={12}>
          <ECSelectField
            label='Часовой пояс'
            name='timezone'
            options={moment.tz.names()}
            fid={e => e}
            fname={e => e}
            form={form}
            initial={initial}
          />
        </Grid>

        {initial.closed ? (
          <Grid size={12}>
            <Typography>Мероприятие закрыто</Typography>
          </Grid>
        ) : null}
      </Grid>
    </>
  );
};

export default MeetupEditForm;
